import { create, v, w } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { numeral } from '@holmescorp/numeral';
import { lccstate, userstate, createNlsMiddleware, childmap, keymap, pathmap, recommended, contentTrack } from '@holmescorp/lcc-state';
import { CompletedViz } from '@holmescorp/prepost-viz';
import { YouAreHere } from './you-are-here';
import { ContentOrRecommended } from './content-or-recommended';
import { ContentOrder } from './content-order';
import { RecommendedOrder } from './recommended-order';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import css from '../css/explore-view.m.css';
import { resourceDitabookSelector } from '@holmescorp/resource-parser';
const nls = createNlsMiddleware('ditabook');
const icache = createICacheMiddleware();
const factory = create({
    icache,
    theme,
    nls,
    lccstate,
    userstate,
    recommended,
    contentTrack
}).properties();
export const ExploreView = factory(({ properties, middleware: { icache, theme, nls, lccstate, userstate, recommended, contentTrack } }) => {
    icache.getOrSet('inited', () => {
        contentTrack.setup();
        return true;
    });
    const themeCss = theme.classes(css);
    const { get, path } = lccstate;
    const roots = get(path('ditaroots'));
    const topic = {
        attributes: { key: `content-view` },
        children: []
    };
    const { switchView } = properties();
    const completedPercent = contentTrack.percentComplete();
    const { format } = nls();
    const completed_note = format('completed_percent', { percent: numeral(completedPercent).format('0%') });
    const topicsets = roots.map((root) => {
        const kidkeys = childmap.get(root) || [];
        return kidkeys.map((tgf) => {
            const { path } = keymap.get(tgf);
            const { topic } = pathmap.get(path);
            return { ...topic };
        });
    });
    const hasAssess = recommended.hasAssessment();
    const hideCompleted = icache.getOrSet('hideCompleted', false);
    const { get: uget, path: upath } = userstate;
    const contentorder = uget(upath('toolstate', 'contentorder')) || {
        extra: hasAssess ? 'recommended' : 'content',
        hide: true
    };
    const orderView = icache.getOrSet('orderView', contentorder.extra ? contentorder.extra : hasAssess ? 'recommended' : 'content');
    const shouldHideCompleted = (hide) => {
        icache.set('hideCompleted', hide);
    };
    const showOrderView = (order) => {
        icache.set('orderView', order);
    };
    topic.children = topicsets.flat();
    return v('div', { key: 'explore-view', classes: [themeCss.root], xqa: 'view study' }, [
        w(YouAreHere, { active: 'study', switchView }),
        v('div', {
            id: 'tabPanelStudy',
            ...formatAriaProperties({
                labelledby: 'studyTab'
            }),
            key: 'about-study',
            classes: [themeCss.about]
        }, [
            w(resourceDitabookSelector, {
                topic: hasAssess ? 'study_invite' : 'study_assess_prompt',
                key: 'study-invite',
                classes: [themeCss.about]
            }),
            w(ContentOrRecommended, {
                initialSelection: orderView,
                shouldHideCompleted,
                showOrderView
            }),
            v('div', { xqa: 'note completed', classes: [themeCss.completedNote] }, [completed_note]),
            w(CompletedViz, { percent: completedPercent, xqa: 'viz completed' })
        ]),
        orderView === 'content' ? w(ContentOrder, { hideCompleted }) : w(RecommendedOrder, { hideCompleted })
    ]);
});
